import { render, staticRenderFns } from "./CountryFlagDisplay.vue?vue&type=template&id=1a85b05b&scoped=true"
import script from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
export * from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
import style0 from "./CountryFlagDisplay.vue?vue&type=style&index=0&id=1a85b05b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85b05b",
  null
  
)

export default component.exports